
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Checkbox, Dialog, MD2Colors, Text, TextInput } from 'react-native-paper';
import { fontConfig } from '../../theme/theme';

const PAYMENT_MODES = ['Cash', 'Card', 'UPI'];

function SplitPaymentDIalog({ visible, hideDialog, amount, onSplitPaymentReceived }) {
    const [total, setTotal] = useState(0);
    const [error, setError] = useState('');

    const setPaymentData = () =>
        PAYMENT_MODES.reduce((acc, mode) => {
            acc[mode] = { status: 'unchecked', amount: '' };
            return acc;
        }, {});

    const [payments, setPayments] = useState(setPaymentData());

    const togglePaymentMode = (mode) => {
        setPayments((prev) => ({
            ...prev,
            [mode]: {
                ...prev[mode],
                status: prev[mode].status === 'checked' ? 'unchecked' : 'checked',
            },
        }));
    };

    const updateAmount = (mode, value) => {
        setPayments((prev) => ({
            ...prev,
            [mode]: {
                ...prev[mode],
                amount: value,
            },
        }));
    };

    useEffect(() => {
        if (visible) {
            setPayments(setPaymentData());
        }
    }, [visible]);

    useEffect(() => {

        const currentTotal = Object.entries(payments)
            .filter(([_, val]) => val.status === 'checked')
            .reduce((sum, [_, val]) => sum + parseFloat(val.amount || 0), 0);
        setTotal(currentTotal);
        setError(currentTotal > amount ? 'Amount exceeds grand total' : '');

    }, [payments, amount]);

    const handleSpiltSubmit = () => {
        const selectedPayments = Object.entries(payments)
            .filter(([_, val]) => val.status === 'checked' && parseFloat(val.amount || 0) > 0)
            .map(([mode, val]) => ({
                mode,
                amount: parseFloat(val.amount || 0),
            }));
        const paymentString = selectedPayments.map(p => `${p.mode}:${p.amount}`).join(', ');
        console.log('selectedPayments', paymentString);
        onSplitPaymentReceived?.(paymentString);
    };


    return (
        <React.Fragment>
            <Dialog visible={visible} onDismiss={hideDialog}>
                <Dialog.Title style={{ ...fontConfig.titleSmall }}>Split Payment</Dialog.Title>
                <Dialog.Content>
                    {PAYMENT_MODES.map((mode) => {
                        const isChecked = payments[mode].status === 'checked';
                        const isDisabled = total >= amount && !payments[mode].amount;
                        return (
                            <View
                                key={mode}
                                style={{ flexDirection: 'row', justifyContent: 'space-between', gap: 8, alignItems: 'center', marginVertical: 4 }}
                            >
                                <Checkbox.Item
                                    position="leading"
                                    style={styles.checkBoxItem}
                                    labelStyle={styles.checkBoxItemLabel}
                                    label={mode}
                                    status={payments[mode].status}
                                    onPress={() => togglePaymentMode(mode)}
                                />
                                <TextInput
                                    contentStyle={{ fontSize: 12 }}
                                    placeholder={`Enter ${mode} Amount`}
                                    value={payments[mode].amount}
                                    onChangeText={(value) => updateAmount(mode, value)}
                                    keyboardType="numeric"
                                    editable={isChecked && !isDisabled}
                                    style={{ flex: 1, marginLeft: 8 }} />
                            </View>
                        );
                    })}
                    <Text style={{ marginTop: 10, fontWeight: 'bold' }}>
                        Remaining: ₹{(amount - total).toFixed(2)} / ₹{amount.toFixed(2)}
                    </Text>
                    {!!error && <Text style={{ color: MD2Colors.red800, marginVertical: 2 }}>{error}</Text>}
                </Dialog.Content>
                <Dialog.Actions>
                    <Button onPress={hideDialog}>Cancel</Button>
                    <Button onPress={handleSpiltSubmit} disabled={total !== amount || !!error}>OK</Button>
                </Dialog.Actions>
            </Dialog>
        </React.Fragment>
    );
}

const styles = StyleSheet.create({
    modalConatiner: {
        margin: 0,
        // flex: 1,
        justifyContent: 'flex-end',
    },
    modalView: {
        // flexGrow: 1,
        minHeight: '20%',
        backgroundColor: '#ffffff',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    closeIcon: {
        position: 'absolute',
        top: 10, // Adjust as needed
        right: 10, // Adjust as needed
        backgroundColor: '#FFF',
        borderRadius: 20, // Makes it circular if height and width are equal
        width: 32,
        height: 32,
        justifyContent: 'center',
        alignItems: 'center',
    },
    checkBoxItem: {
        paddingVertical: 2,
    },
    checkBoxItemLabel: {
        fontSize: 12,
    },
});

export default SplitPaymentDIalog;
